<template>
  <DialogTemplate
    :icon-header="iconHeder"
    :close-click-outside="closeClickOutside"
  >
    <template #header>{{ title }}</template>

    <p>{{ label }}</p>
    <div class="loading">
      <ProgressCircle
        :size="40"
        :stroke="4"
        :progress="progress"
        class="progress"
      />
    </div>
  </DialogTemplate>
</template>
<script lang="ts" setup>
interface Props {
  iconHeder?: string;
  title?: string;
  label: string;
  closeClickOutside?: boolean;
  progress: number;
}
defineProps({
  iconHeder: { default: 'nomad:tools' },
  title: { default: 'Nomad Education' },
  label: null,
  closeClickOutside: { type: Boolean, default: false },
  progress: null
});
</script>
<style lang="scss" scoped>
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
